export const MODAL_CLOSE = 'MODAL_CLOSE';

export const closeModal = () => ({
  type: MODAL_CLOSE,
});
